import { createContext, useContext } from "react";
var StoreContext = createContext(void 0),
    Provider = StoreContext.Provider,
    Consumer = StoreContext.Consumer;
export { Provider as StoreProvider, Consumer as StoreConsumer, StoreContext };
export function useStore() {
  return useContext(StoreContext);
}